// extracted by mini-css-extract-plugin
export default {"BasicInfoContainer":"BasicInfo_BasicInfoContainer__ONoQL"};